import React from 'react'
import '../assets/css/footer.css'
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import PinterestIcon from '@material-ui/icons/Pinterest';
import InstagramIcon from '@material-ui/icons/Instagram';
import { Box, Link, Typography } from '@material-ui/core';
// https://preview.colorlib.com/theme/bft/bootstrap-footer-04/


export default function Footer() {

    function Copyright() {
        return (
            <Typography variant="body2" style={{ color: '#902a2a' }} align="center">
                {'Copyright © '}
                <Link color="inherit" href="http://sp-software.tk/" style={{ color: '#902a2a' }} >
                    sp-software.tk
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        );
    }

    return (
        <footer className="app-footer">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-md-3">
                        <a href="#" className="footer-site-logo">xXx</a>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit officiis corporis optio natus. </p>
                    </div>
                    <div className="col-md-2 ml-auto">
                        <h3>Shop</h3>
                        <ul className="list-unstyled links">
                            <li><a href="#">Sell online</a></li>
                            <li><a href="#">Features</a></li>
                            <li><a href="#">Examples</a></li>
                            <li><a href="#">Website editors</a></li>
                            <li><a href="#">Online retail</a></li>
                        </ul>
                    </div>
                    <div className="col-md-2 ml-auto">
                        <h3>Press</h3>
                        <ul className="list-unstyled links">
                            <li><a href="#">Events</a></li>
                            <li><a href="#">News</a></li>
                            <li><a href="#">Awards</a></li>
                            <li><a href="#">Testimonials</a></li>
                            <li><a href="#">Online retail</a></li>
                        </ul>
                    </div>
                    <div className="col-md-2 ml-auto">
                        <h3>About</h3>
                        <ul className="list-unstyled links">
                            <li><a href="#">Contact</a></li>
                            <li><a href="#">Services</a></li>
                            <li><a href="#">Team</a></li>
                            <li><a href="#">Career</a></li>
                            <li><a href="#">Contacts</a></li>
                        </ul>
                    </div>
                </div>

                <hr />


                <div className="footer-end v-between">
                    {/* <div className="col-12 pb-4">
                        <div className="line"></div>
                    </div> */}

                    <div >
                        <ul className="list-unstyled link-menu nav-left">
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Terms &amp; Conditions</a></li>
                            <li><a href="#">Code of Conduct</a></li>
                        </ul>
                    </div>

                    <div >
                        <ul className="list-unstyled social nav-right">
                            <li><a href="#"> <FacebookIcon /> </a></li>
                            <li><a href="#"> <TwitterIcon /> </a></li>
                            <li><a href="#"> <PinterestIcon /> </a></li>
                            <li><a href="#"> <InstagramIcon /> </a></li>
                        </ul>
                    </div>
                </div>


                <Box>
                    <Copyright />
                </Box>

            </div>
        </footer >
    )
}
